<template>
  <div class="search-module">
    <!-- Filtro Data Da e A -->
    <div class="filter-group">
      <label for="startDate">Data Da:</label>
      <input type="date" v-model="selectedFilters.startDate" id="startDate" class="filter-input-date" />

      <label for="endDate">Data A:</label>
      <input type="date" v-model="selectedFilters.endDate" id="endDate" class="filter-input-date" />
    </div>

    <!-- Filtro Data Consegna Da e A -->
    <div class="filter-group">
      <label for="deliveryStartDate">Data Consegna Da:</label>
      <input type="date" v-model="selectedFilters.deliveryStartDate" id="deliveryStartDate" class="filter-input-date" />

      <label for="deliveryEndDate">Data Consegna A:</label>
      <input type="date" v-model="selectedFilters.deliveryEndDate" id="deliveryEndDate" class="filter-input-date" />
    </div>

    <!-- Filtro Email -->
    <div class="filter-group">
      <label for="emailFilter">Ricerca per Email:</label>
      <input 
        v-model="selectedFilters.email" 
        type="text" 
        id="emailFilter" 
        class="filter-input" 
        placeholder="Inserisci email" 
      />
    </div>

    <!-- Filtro Studio -->
    <div class="filter-group" ref="dropdownContainer">
<label for="selectedStudio">Studio:</label>

<!-- Input simulato che mostra le selezioni correnti -->
<div class="custom-select" @click="toggleDropdown">
  {{ selectedFilters.studio.length ? selectedFilters.studio.join(', ') : 'Seleziona uno studio' }}
  <span class="arrow">&#9660;</span>
</div>

<!-- Dropdown con le checkbox -->
<div v-if="dropdownOpen" class="checkbox-dropdown">
  <div v-for="option in studioOptions" :key="option" class="checkbox-item">
    <input
      type="checkbox"
      :id="option"
      :value="option"
      v-model="selectedFilters.studio"
    />
    <label :for="option">{{ option }}</label>
  </div>
</div>
</div>





    <!-- Filtro Videocall -->
    <div class="filter-group">
      <label for="videocallFilter">Videocall (ultime 2):</label>
      <select v-model="selectedFilters.videocall" id="videocallFilter" class="filter-input">
        <option disabled value="">Seleziona stato</option>
        <option value="chiamata">Chiamata</option>
        <option value="videocallfatta">Videocall Fatta</option>
        <option value="nonrisponde">Non risponde</option>
        <option value="ciricontatta">Ci ricontatta</option>
        <option value="inviatamail">Inviata mail</option>
        <option value="inviatoticket">Inviato Ticket</option>
        <option value="secondacall">Seconda call</option>
        <option value="rinnovo">Rinnovo</option>
      </select>
    </div>


    <div class="filter-group">
  <label for="nutrizionistaFilter">Nutr. Alimentazione</label>
  <select v-model="selectedFilters.nutrizionistadiet" id="nutrizionistaFilter" class="filter-input">
    <option disabled value="">Seleziona nutrizionista</option>
    <option value="">Nessuna nutrizionista</option> <!-- Campo vuoto -->
    <option value="francescadg">Francesca D.G.</option>
    <option value="celestina">Celestina</option>
    <option value="celestина">Celestина</option>
    <option value="erika">Erika</option>
    <option value="martina">Martina</option>
    <option value="francesca">Francesca</option>
  </select>
</div>






    <!-- Filtro Note -->
    <div class="filter-group">
      <label for="noteFilter">Note:</label>
      <select v-model="selectedFilters.note" id="noteFilter" class="filter-input">
        <option disabled value="">Seleziona stato</option>
        <option value="damodificare">Da modificare</option>
        <option value="corretta">Corretta</option>
      </select>
    </div>

    <!-- Filtro Colore -->
    <div class="filter-group">
      <label for="colorFilter">Colore:</label>
      <select v-model="selectedFilters.color" id="colorFilter" class="filter-input">
        <option disabled value="">Seleziona colore</option>
        <option value="red">Rosso - no consegna </option>
        <option value="blue">Blu - video call da fare</option>
        <option value="yellow">Giallo - Uomo</option>
        <option value="protocollo">PROTOCOLLO 25</option>
        <option value="green">Verde - solo allenamento</option>
        <option value="pink">Rosa - solo dieta</option>
        <option value="">Nessun colore</option>
      </select>
    </div>

    <!-- Bottone Cerca -->
    <div class="filter-actions">
      <button @click="applyFilters" class="filter-button">Cerca</button>
      <button @click="resetFilters" class="filter-button reset">Reset</button>
      <button @click="scrollToBottom" class="filter-button fine">Fine tabella</button>
      <button @click="scrollToTop" class="filter-button fine">Inizio tabella</button>
<!--
      <button @click="clearAllFilters" class="filter-button reset">Cancella Tutto</button>
      <button @click="refreshDeliveryDates" class="refresh-button">Aggiorna Date di Consegna</button>
-->
    </div>


    <div class="filter-actions">
      <button @click="exportToCSVTrainer" class="filter-button">Esporta CSV Trainer</button>
<!--
      <button @click="exportToCSV" class="filter-button">Esporta CSV</button>


<button @click="filterUsersWithoutAlimentazioneId" class="filter-button">
Mostra utenti con alimentazioni senza ID
</button>

<button @click="addMissingIdsForFilteredUsers" class="filter-button">
Aggiungi ID mancanti agli utenti filtrati
</button>
-->
</div>


</div>
</template>

<script>
import { collection, getDocs, getFirestore, doc, updateDoc, getDoc } from "firebase/firestore";
import { formatIntegrationPrice, getLegacyIntegrationLabels, getVitastrongBundles, hasLegacyIntegration } from "@/lib/integrazione";

const DEFAULT_DELIVERY_RANGE_DAYS = 3;
const STUDIO_OPTIONS = [
  "Tivoli Quartier generale",
  "FF Genova",
  "FF Bologna",
  "FF Bari",
  "FF Pescara",
  "FF Firenze",
  "FF Torino",
  "FF Napoli",
  "FF Milano",
  "FF Roma",
  "FF Salerno",
  "FF Cagliari",
  "FF Milano Citta Studi",
  "FF Roma Eur",
  "FF Milano Sempione",
  "FF Padova"
];

function createEmptyFilters() {
  return {
    studio: [],
    startDate: "",
    endDate: "",
    deliveryStartDate: "",
    deliveryEndDate: "",
    videocall: "",
    note: "",
    color: null,
    email: "",
    nutrizionistadiet: null
  };
}

function cloneFilters(filters) {
  return JSON.parse(JSON.stringify(filters || {}));
}

function toMillis(value) {
  if (!value) return null;
  if (typeof value.toDate === "function") {
    return value.toDate().getTime();
  }
  if (value instanceof Date) {
    return value.getTime();
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed.getTime();
}

function addBusinessDays(baseDate, businessDaysToAdd) {
  const result = new Date(baseDate);
  let addedDays = 0;

  while (addedDays < businessDaysToAdd) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay();
    if (day !== 0 && day !== 6) {
      addedDays += 1;
    }
  }

  return result;
}

function formatBundlePrices(bundles) {
  const pricedBundles = bundles.filter((bundle) => Number.isFinite(bundle?.priceCents));
  const breakdown = pricedBundles.map((bundle) => (
    `${bundle.title}: ${formatIntegrationPrice(bundle.priceCents, bundle.currency)}`
  ));

  if (pricedBundles.length > 1 && pricedBundles.length === bundles.length) {
    const currencies = new Set(pricedBundles.map((bundle) => bundle.currency || "EUR"));
    if (currencies.size === 1) {
      const currency = pricedBundles[0].currency || "EUR";
      const totalCents = pricedBundles.reduce((total, bundle) => total + bundle.priceCents, 0);
      breakdown.push(`Totale bundle: ${formatIntegrationPrice(totalCents, currency)}`);
    }
  }

  return breakdown.join(" | ");
}

export default {
  props: {
    userData: {
      type: Array,
      required: true
    },
    initialFilters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dropdownOpen: false,
      studioOptions: STUDIO_OPTIONS,
      selectedFilters: this.buildInitialFilters(),
      filteredUserData: []
    };
  },
  mounted() {
    this.applyFilters();
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  watch: {
    userData: {
      handler() {
        this.applyFilters();
      }
    },
    initialFilters: {
      deep: true,
      handler() {
        this.selectedFilters = this.buildInitialFilters();
        this.applyFilters();
      }
    }
  },
  methods: {
    buildInitialFilters() {
      const defaults = createEmptyFilters();
      const today = new Date();
      const deliveryEnd = addBusinessDays(today, DEFAULT_DELIVERY_RANGE_DAYS);

      defaults.deliveryStartDate = today.toISOString().split("T")[0];
      defaults.deliveryEndDate = deliveryEnd.toISOString().split("T")[0];

      if (this.initialFilters && Object.keys(this.initialFilters).length) {
        return {
          ...defaults,
          ...cloneFilters(this.initialFilters)
        };
      }

      return defaults;
    },

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    closeDropdown() {
      this.dropdownOpen = false;
    },

    handleClickOutside(event) {
      const dropdown = this.$refs.dropdownContainer;
      if (dropdown && !dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    },

    async refreshDeliveryDates() {
      try {
        const db = getFirestore();
        const usersRef = collection(db, "nomeDellaTuaCollectionUtenti");
        const querySnapshot = await getDocs(usersRef);

        const updatedUserData = querySnapshot.docs.map((docSnap) => ({
          ...docSnap.data(),
          id: docSnap.id
        }));

        this.$emit("updateUserData", updatedUserData);
        console.log("Date di consegna aggiornate visivamente.");
      } catch (error) {
        console.error("Errore durante il refresh visuale delle date di consegna:", error);
        alert("Errore durante il refresh. Controlla i log per i dettagli.");
      }
    },

    filterUsersWithoutAlimentazioneId() {
      if (!Array.isArray(this.userData)) {
        this.filteredUserData = [];
        this.$emit("filtered-data", []);
        return;
      }

      this.filteredUserData = this.userData.filter((user) =>
        Array.isArray(user.alimentazioni) &&
        user.alimentazioni.some((alimentazione) => !alimentazione.id || alimentazione.id.trim() === "")
      );

      console.log("Utenti con alimentazioni senza ID:", this.filteredUserData);
      alert(`Trovati ${this.filteredUserData.length} utenti con alimentazioni senza ID.`);
      this.$emit("filtered-data", this.filteredUserData);
    },

    async addMissingIdsForFilteredUsers() {
      try {
        const db = getFirestore();

        for (const user of this.filteredUserData) {
          const docRef = doc(db, "inviidigiornata", user.id);
          const docSnap = await getDoc(docRef);

          if (!docSnap.exists()) {
            console.warn(`Documento non trovato per utente: ${user.id}`);
            continue;
          }

          const docData = docSnap.data();
          let hasUpdated = false;

          docData.alimentazioni = (docData.alimentazioni || []).map((alimentazione) => {
            if (!alimentazione.id || alimentazione.id.trim() === "") {
              alimentazione.id = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
              hasUpdated = true;
            }
            return alimentazione;
          });

          if (hasUpdated) {
            await updateDoc(docRef, { alimentazioni: docData.alimentazioni });
            console.log(`ID mancanti aggiunti per utente: ${user.id}`);
          } else {
            console.log(`Tutti gli ID sono già presenti per utente: ${user.id}`);
          }
        }

        alert("Processo completato: ID mancanti aggiunti per gli utenti filtrati.");
      } catch (error) {
        console.error("Errore durante l'aggiunta degli ID mancanti:", error);
        alert("Errore durante l'operazione. Controlla i log per maggiori dettagli.");
      }
    },

    async exportToCSV() {
      try {
        const db = getFirestore();
        const querySnapshot = await getDocs(collection(db, "inviidigiornata"));

        let csvContent = "data:text/csv;charset=utf-8,";
        const headers = [
          "ID Utente",
          "Nome",
          "Cognome",
          "Email",
          "Telefono",
          "Data Creazione",
          "Data Consegna",
          "Studio",
          "Colore Riga",
          "Note Alimentazione",
          "Note Allenamento",
          "Note Generali",
          "ID Alimentazione",
          "Data Creazione Alimentazione",
          "Kcal Alimentazioni",
          "Strategia",
          "Piano Integrazione",
          "Allenamento",
          "Freq Allenamento",
          "Lav Trainer",
          "Lavorato",
          "Videocall",
          "Nota 1",
          "Nota 2",
          "Nota Interna",
          "Nutrizionista",
          "Nutrizionista Diet",
          "Link Alimentazione",
          "Data Selezione SI",
          "Note Interna",
          "Note Select",
          "Note Trainer",
          "Partner Integrazione",
          "Bundle Integrazione",
          "Prodotti Integrazione",
          "Prezzi Bundle / Totale",
          "Link Acquisto Bundle"
        ];
        csvContent += headers.join(";") + "\\n";

        const cleanField = (field) => {
          if (!field) return "";
          const cleaned = String(field).replace(/\\n/g, " ").replace(/;/g, ",");
          return `"${cleaned}"`;
        };

        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          const baseFields = [
            cleanField(docSnap.id),
            cleanField(data.name),
            cleanField(data.surname),
            cleanField(data.email),
            cleanField(data.phone),
            cleanField(data.createdAt ? data.createdAt.toDate().toLocaleString("it-IT") : ""),
            cleanField(data.dataConsegna ? data.dataConsegna.toDate().toLocaleString("it-IT") : ""),
            cleanField(data.studio),
            cleanField(data.rowColor),
            cleanField(data.noteAlimentazione),
            cleanField(data.noteAllenamento),
            cleanField(data.notes)
          ];

          const alimentazioni = Array.isArray(data.alimentazioni) ? data.alimentazioni : [];
          if (!alimentazioni.length) {
            csvContent += baseFields.join(";") + "\\n";
            return;
          }

          alimentazioni.forEach((alimentazione) => {
            const legacy = hasLegacyIntegration(alimentazione);
            const bundles = legacy ? [] : getVitastrongBundles(alimentazione);
            const alimentazioneFields = [
              cleanField(alimentazione.id),
              cleanField(alimentazione.dataCreazione ? alimentazione.dataCreazione.toDate().toLocaleString("it-IT") : ""),
              cleanField(alimentazione.kcalalimentazioni),
              cleanField(alimentazione.strategia),
              cleanField(alimentazione.pianoIntegrazione),
              cleanField(alimentazione.allenamento),
              cleanField(alimentazione.freqallenamento),
              cleanField(alimentazione.lavtrainer),
              cleanField(alimentazione.lavorato),
              cleanField(alimentazione.videocall),
              cleanField(alimentazione.nota1),
              cleanField(alimentazione.nota2),
              cleanField(alimentazione.notaInterna),
              cleanField(alimentazione.nutrizionista),
              cleanField(alimentazione.nutrizionistadiet),
              cleanField(alimentazione.linkAlimentazione),
              cleanField(alimentazione.dataSelezioneSI ? alimentazione.dataSelezioneSI.toDate().toLocaleString("it-IT") : ""),
              cleanField(alimentazione.noteInterna),
              cleanField(alimentazione.noteselect),
              cleanField(alimentazione.notetrainer),
              cleanField(legacy ? "Yamamoto (storico)" : bundles.length ? "Vitastrong" : ""),
              cleanField(bundles.map((bundle) => bundle.title).join(" | ")),
              cleanField(legacy
                ? getLegacyIntegrationLabels(alimentazione).join(", ")
                : bundles.map((bundle) => `${bundle.title}: ${bundle.products.join(", ")}`).join(" | ")),
              cleanField(formatBundlePrices(bundles)),
              cleanField(bundles.map((bundle) => `${bundle.title}: ${bundle.purchaseUrl}`).join(" | "))
            ];

            csvContent += [...baseFields, ...alimentazioneFields].join(";") + "\\n";
          });
        });

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "inviidigiornata_completo.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert("Esportazione completata!");
      } catch (error) {
        console.error("Errore durante l'esportazione in CSV:", error);
        alert("Errore durante l'esportazione. Controlla i log per maggiori dettagli.");
      }
    },

    exportToCSVTrainer() {
      try {
        if (!this.filteredUserData.length) {
          alert("Nessun dato filtrato da esportare.");
          return;
        }

        let csvContent = "data:text/csv;charset=utf-8,";
        const headers = ["Data", "Studio", "Email", "Nome", "Cognome"];
        csvContent += headers.join(";") + "\\n";

        const cleanField = (field) => {
          if (!field) return "";
          const cleaned = String(field).replace(/\\n/g, " ").replace(/;/g, ",");
          return `"${cleaned}"`;
        };

        const formatDate = (timestamp) => {
          if (!timestamp) return "";
          const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
          return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString("it-IT");
        };

        this.filteredUserData.forEach((user) => {
          const row = [
            cleanField(user.dataConsegna ? formatDate(user.dataConsegna) : ""),
            cleanField(user.studio),
            cleanField(user.email),
            cleanField(user.name),
            cleanField(user.surname)
          ];
          csvContent += row.join(";") + "\\n";
        });

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "inviidigiornata_trainer.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert("Esportazione completata!");
      } catch (error) {
        console.error("Errore durante l'esportazione in CSV trainer:", error);
        alert("Errore durante l'esportazione. Controlla i log per maggiori dettagli.");
      }
    },

    scrollToBottom() {
      const dataTable = document.querySelector("table");
      if (dataTable) {
        dataTable.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    },

    scrollToTop() {
      const dataTable = document.querySelector("table");
      if (dataTable) {
        dataTable.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },

    normalizeFilters(rawFilters = {}) {
      const normalizeDate = (value, endOfDay = false) => {
        if (!value) return null;
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return null;
        if (endOfDay) {
          date.setHours(23, 59, 59, 999);
        } else {
          date.setHours(0, 0, 0, 0);
        }
        return date.getTime();
      };

      const studios = Array.isArray(rawFilters.studio) ? rawFilters.studio.filter(Boolean) : [];
      const startCreatedAt = rawFilters.startDate ? normalizeDate(rawFilters.startDate) : null;
      const endCreatedAt = rawFilters.endDate ? normalizeDate(rawFilters.endDate, true) : null;
      const startDelivery = rawFilters.deliveryStartDate ? normalizeDate(rawFilters.deliveryStartDate) : null;
      const endDelivery = rawFilters.deliveryEndDate ? normalizeDate(rawFilters.deliveryEndDate, true) : null;

      return {
        studioSet: studios.length ? new Set(studios) : null,
        hasCreatedRange: startCreatedAt !== null && endCreatedAt !== null,
        startCreatedAt,
        endCreatedAt,
        hasDeliveryRange: startDelivery !== null && endDelivery !== null,
        startDelivery,
        endDelivery,
        videocall: rawFilters.videocall || "",
        note: rawFilters.note || "",
        color: rawFilters.color ?? null,
        email: rawFilters.email ? rawFilters.email.trim().toLowerCase() : "",
        nutrizionistadiet: rawFilters.nutrizionistadiet ?? null
      };
    },

    matchesFilters(user, filters) {
      if (!user) return false;

      if (filters.studioSet && !filters.studioSet.has(user.studio)) {
        return false;
      }

      if (filters.email) {
        const email = (user.email || "").toLowerCase();
        if (!email.includes(filters.email)) {
          return false;
        }
      }

      const createdAt = toMillis(user.createdAt);
      if (filters.hasCreatedRange) {
        if (createdAt === null || createdAt < filters.startCreatedAt || createdAt > filters.endCreatedAt) {
          return false;
        }
      }

      const deliveryAt = toMillis(user.dataConsegna);
      if (filters.hasDeliveryRange) {
        if (deliveryAt === null || deliveryAt < filters.startDelivery || deliveryAt > filters.endDelivery) {
          return false;
        }
      }

      if (filters.color !== null) {
        if (filters.color === "") {
          if (user.rowColor && user.rowColor !== "") {
            return false;
          }
        } else if (user.rowColor !== filters.color) {
          return false;
        }
      }

      const alimentazioni = Array.isArray(user.alimentazioni) ? user.alimentazioni : [];

      if (filters.videocall) {
        const lastTwo = alimentazioni.slice(-2);
        const hasVideocall = lastTwo.some((alim) => (alim?.videocall || "") === filters.videocall);
        if (!hasVideocall) {
          return false;
        }
      }

      if (filters.nutrizionistadiet !== null) {
        const lastAlimentazione = alimentazioni[alimentazioni.length - 1];
        if (filters.nutrizionistadiet === "") {
          if (lastAlimentazione && lastAlimentazione.nutrizionistadiet) {
            return false;
          }
        } else if (!lastAlimentazione || lastAlimentazione.nutrizionistadiet !== filters.nutrizionistadiet) {
          return false;
        }
      }

      if (filters.note) {
        const lastAlimentazione = alimentazioni[alimentazioni.length - 1];
        if (!lastAlimentazione || lastAlimentazione.noteselect !== filters.note) {
          return false;
        }
      }

      return true;
    },

    applyFilters() {
      if (!Array.isArray(this.userData)) {
        this.filteredUserData = [];
        this.$emit("filters-changed", cloneFilters(this.selectedFilters));
        this.$emit("filtered-data", []);
        return;
      }

      const normalized = this.normalizeFilters(this.selectedFilters);
      const filtered = this.userData.filter((user) => this.matchesFilters(user, normalized));

      this.filteredUserData = filtered;
      this.$emit("filters-changed", cloneFilters(this.selectedFilters));
      this.$emit("filtered-data", filtered);
    },

    resetFilters() {
      this.selectedFilters = this.buildInitialFilters();
      this.applyFilters();
    },

    clearAllFilters() {
      this.selectedFilters = createEmptyFilters();
      this.applyFilters();
    }
  }
};
</script>

<style scoped>
.filter-group #selectedStudio {
flex-grow: 1;
min-width: 200px; /* Larghezza minima */
}

.custom-select {
display: flex;
justify-content: space-between;
align-items: center;
padding: 10px;
border: 1px solid #ccc;
border-radius: 8px;
background-color: #fff;
cursor: pointer;
width: 100%;
}

.arrow {
margin-left: 10px;
font-size: 12px;
color: #555;
}

.checkbox-dropdown {
position: absolute;
background-color: #424242;
border: 1px solid #616161;
border-radius: 8px;
padding: 10px;
width: 223px;
max-height: 223px;
overflow-y: auto;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
z-index: 1000;
}

.checkbox-item {
display: flex;
align-items: center;
gap: 5px;
margin-bottom: 5px;
}


.checkbox-list {
display: flex;
flex-wrap: wrap;
gap: 10px;
padding: 10px;
border: 1px solid #ccc;
border-radius: 8px;
background-color: #fff;
height: 150px; /* Limita l'altezza */
width: 100px;
overflow-y: auto; /* Aggiunge lo scroll verticale */
}

.checkbox-item {
display: flex;
align-items: center;
gap: 5px;
}

.checkbox-item input[type="checkbox"] {
width: 16px;
height: 16px;
}



.filter-input[multiple] {
height: auto; /* Permette alla select di crescere in altezza */
min-height: 100px; /* Altezza minima */
padding: 10px;
border: 1px solid #787878;
border-radius: 8px;
background-color: #3e3e3e;
font-size: 14px;
color: #333;
overflow-y: auto; /* Aggiunge uno scroll verticale se necessario */
outline: none;
}



.search-module {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #dddddd; /* Sfondo leggero per evidenziare il blocco */
  border-radius: 8px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  margin-right: 15px;
  flex: 1; /* Per far adattare le dimensioni dei campi */
  margin-top: 10px
}

.filter-group label {
  font-weight: 600;
  margin-bottom: 5px;
  color: #f1f1f1;
  margin-top: 10px;
}

.filter-input-date {
  border: 1px solid #ccc;
  border-radius: 14px;
  font-size: 14px;
  background-color: rgb(255, 255, 255);
  color: #333;
  transition: border-color 0.3s ease;
  width: 147px;
  padding-left: 10px;
  margin-right: 0px;
}

.filter-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 14px;
  font-size: 14px;
  background-color: rgb(255, 255, 255);
  color: #333;
  transition: border-color 0.3s ease;
}

.filter-input:focus {
  border-color: #4caf50; /* Verde in evidenza al focus */
  outline: none;
}

.filter-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.filter-button {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: #4caf50;
  color: white;
  transition: background-color 0.3s ease;
}

.filter-button.reset {
  background-color: #f44336;
}

.filter-button.fine {
  background-color: #7f7f7f;
}

.filter-button:hover {
  background-color: #45a049;
}

.filter-button.reset:hover {
  background-color: #e53935;
}

.filter-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Miglioramenti visivi per le Select */
.filter-input option {
  font-weight: normal;
  color: #333;
}

.color-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  background-color: #fff;
}

.color-select:focus {
  border-color: #4caf50;
}
</style>
